"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _components2 = require("./components");
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
var _auth = require("@/utils/auth");
var _Monitoring = _interopRequireDefault(require("./components/Monitoring.vue"));
var _constants = require("@/config/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import io from 'socket.io-client'
// import Cookies from 'js-cookie'
var now = new Date();
var _default = exports.default = {
  name: 'Dashboard',
  bodyClass: 'dashboard-page',
  components: {
    CardDashboardMonitor: _components.CardDashboardMonitor,
    CardApiConsultDead: _components.CardApiConsultDead,
    CardApiRequest: _components.CardApiRequest,
    CardFilterDays: _components.CardFilterDays,
    ModalDetailCard: _components2.ModalDetailCard,
    Monitoring: _Monitoring.default
  },
  data: function data() {
    return {
      TYPE_ITEM_DASHBOARD: _constants.TYPE_ITEM_DASHBOARD,
      isLoadingReceptionist: false,
      listServicesOnErrorTransactions: [],
      dates: [now, now],
      formatHour: 'DD/MM/YYYY - HH:mm:ss',
      lastUpdate: null,
      intervalid: null,
      timeDash: '0',
      isLoading: false,
      isLoadingChartIP: false,
      isLoadingChartPath: false,
      isLoadingChartErrors: false,
      typeSelected: _constants.TYPE_ITEM_DASHBOARD.RECEPTIONIST,
      resumeDashboard: {},
      socketInterval: null,
      intervalId: null,
      consolidatedDataPeriod: 'today',
      createdHiveConsolidated: {
        isLoading: true,
        qtyTotal: 0,
        qtyErrors: 0,
        qtySuccess: 0,
        qtyProcessing: 0,
        lastUpdate: null
      },
      createdProviderConsolidated: {
        isLoading: true,
        qtyTotal: 0,
        qtyErrors: 0,
        qtySuccess: 0,
        qtyProcessing: 0,
        lastUpdate: null
      },
      receivedHiveConsolidated: {
        isLoading: true,
        qtyTotal: 0,
        qtyErrors: 0,
        qtySuccess: 0,
        qtyProcessing: 0,
        lastUpdate: null
      },
      sendClientConsolidated: {
        isLoading: true,
        qtyTotal: 0,
        qtyErrors: 0,
        qtySuccess: 0,
        qtyProcessing: 0,
        qtyReceivedFailed: 0,
        lastUpdate: null
      },
      drawerCardDetails: {
        isLoading: true,
        show: false,
        withRequestsError: {
          show: false,
          title: '',
          partOfTheWhole: 0,
          activeTab: 0,
          data: []
        },
        withError: {
          show: false,
          title: '',
          partOfTheWhole: 0,
          activeTab: 0,
          data: []
        },
        inProcessing: {
          show: false,
          title: '',
          partOfTheWhole: 0,
          activeTab: 0,
          data: []
        },
        withSuccess: {
          show: false,
          title: '',
          partOfTheWhole: 0,
          activeTab: 0,
          data: []
        }
      },
      consolidatedQuantitiesOfProtocolsToday: {
        createdHive: {
          total: '---',
          isLoading: true,
          qtyErrors: '---',
          qtySuccess: '---',
          qtyProcessing: '---'
        },
        createdProvider: {
          total: '---',
          isLoading: true,
          qtyErrors: '---',
          qtySuccess: '---',
          qtyProcessing: '---'
        },
        receivedHive: {
          total: '---',
          isLoading: true,
          qtyErrors: '---',
          qtySuccess: '---',
          qtyProcessing: '---'
        },
        receivedClient: {
          total: '---',
          isLoading: true,
          qtyErrors: '---',
          qtySuccess: '---',
          qtyReceivedFailed: '---'
        }
      },
      typesConsults: [{
        value: _constants.TYPE_ITEM_DASHBOARD.RECEPTIONIST,
        name: 'Transacional'
      }, {
        value: _constants.TYPE_ITEM_DASHBOARD.TRANSACTIONS,
        name: 'API Gateway'
      }, {
        value: _constants.TYPE_ITEM_DASHBOARD.MONITORING,
        name: 'Monitoramento'
      }],
      times: [{
        value: '0',
        name: 'Hoje'
      }],
      radarChartParams: null,
      listRequestTotal: [],
      loadingConsolidatedGetsInLastDays: false,
      arrConsolidatedGetsInLastDays: [],
      listTypes: ['withSuccess', 'inProcessing', 'withError', 'withRequestsError'],
      chartDataPaths: {
        labels: [],
        datasets: [{
          label: 'Quantidade',
          backgroundColor: '#36f',
          barThickness: 7,
          borderRadius: 3,
          data: []
        }]
      },
      dataChartIPs: {
        labels: [],
        datasets: [{
          label: 'Quantidade',
          backgroundColor: '#36f',
          barThickness: 7,
          borderRadius: 3,
          data: []
        }]
      },
      chartDataErrors: {
        labels: [],
        datasets: [{
          label: 'Quantidade',
          backgroundColor: '#36f',
          barThickness: 7,
          borderRadius: 3,
          data: []
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['device'])), {}, {
    isMobile: function isMobile() {
      return this.device === 'mobile';
    },
    listServicerOnError: function listServicerOnError() {
      if (this.typeSelected === _constants.TYPE_ITEM_DASHBOARD.RECEPTIONIST) {
        return this.listServicesOnErrorTransactions;
      }
      return [];
    },
    consolidatedData: function consolidatedData() {
      return this.consolidatedQuantitiesOfProtocolsToday;
    },
    isAdmin: function isAdmin() {
      var user = (0, _auth.getUser)().user;
      return user.roleAdmin;
    }
  }),
  watch: {
    timeDash: function timeDash(val) {
      this.updateItems(val);
      this.getConsolidatedGetsInLastDays(val);
    },
    typeSelected: function typeSelected(val) {
      if (val !== _constants.TYPE_ITEM_DASHBOARD.MONITORING) {
        this.updateItems(val);
      }
    }
  },
  created: function created() {
    // getConsolidated
    this.getDataConsolidated('created_hive');
    this.getDataConsolidated('hive_provider');
    this.getDataConsolidated('provider_hive');
    this.getDataConsolidated('hive_client');
    this.getConsolidatedGetsInLastDays(this.timeDash);
    this.getErros();
    if (!this.isAdmin) {
      this.typesConsults = [{
        value: _constants.TYPE_ITEM_DASHBOARD.RECEPTIONIST,
        name: 'Transacional'
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchConsumption', 'fetchListErrorsTransactions', 'fetchListErrorsReceptionist', 'fetchNumberOfItensInLastDays', 'fetchQtyOpenProtocolsInLastDays', 'fetchConsolidatedGetsInLastDays', 'fetchProtocolsDetailsByPhaseGroupByTypeInLastDays', 'fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType', 'fetchDashboardDataConsolidatedCreatedHive', 'fetchDashboardDataConsolidatedCreatedProvider', 'fetchDashboardDataConsolidatedReceivedHive', 'fetchDashboardDataConsolidatedSendClient'])), {}, {
    getDataConsolidated: function () {
      var _getDataConsolidated = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type) {
        var params, functionBind, dataBind, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                days: this.timeDash
              };
              functionBind = this.fetchDashboardDataConsolidatedCreatedHive;
              dataBind = 'createdHiveConsolidated';
              _t = type;
              _context.n = _t === 'hive_provider' ? 1 : _t === 'provider_hive' ? 2 : _t === 'hive_client' ? 3 : 4;
              break;
            case 1:
              functionBind = this.fetchDashboardDataConsolidatedCreatedProvider;
              dataBind = 'createdProviderConsolidated';
              return _context.a(3, 4);
            case 2:
              functionBind = this.fetchDashboardDataConsolidatedReceivedHive;
              dataBind = 'receivedHiveConsolidated';
              return _context.a(3, 4);
            case 3:
              functionBind = this.fetchDashboardDataConsolidatedSendClient;
              dataBind = 'sendClientConsolidated';
              return _context.a(3, 4);
            case 4:
              _context.n = 5;
              return functionBind(params);
            case 5:
              data = _context.v;
              if (data) this[dataBind] = data;
              this[dataBind].isLoading = false;
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDataConsolidated(_x) {
        return _getDataConsolidated.apply(this, arguments);
      }
      return getDataConsolidated;
    }(),
    emitEvent: function emitEvent() {
      // Emite o evento 'requestData' para o servidor
      this.socket.emit('requestData', {
        message: 'Send me data'
      });
    },
    msdkNumber: function msdkNumber(num) {
      return this.$options.filters.maskNumber(num);
    },
    updateItems: function updateItems(val) {
      this.listServicesOnErrorTransactions = [];
      this.getErros();
    },
    getConsolidatedGetsInLastDays: function () {
      var _getConsolidatedGetsInLastDays = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(qtyDays) {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loadingConsolidatedGetsInLastDays = true;
              _context2.n = 1;
              return this.fetchConsolidatedGetsInLastDays({
                days: qtyDays
              });
            case 1:
              data = _context2.v;
              if (data) {
                this.arrConsolidatedGetsInLastDays = data;
              }
              this.loadingConsolidatedGetsInLastDays = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getConsolidatedGetsInLastDays(_x2) {
        return _getConsolidatedGetsInLastDays.apply(this, arguments);
      }
      return getConsolidatedGetsInLastDays;
    }(),
    getErros: function () {
      var _getErros = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var date, startDate, endDate, fn, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              date = (0, _moment.default)().subtract(this.timeDash, 'days');
              startDate = date.format('YYYY-MM-DD');
              endDate = (0, _moment.default)().add(1, 'days').format('YYYY-MM-DD');
              this.isLoadingReceptionist = true;
              fn = this.typeSelected === _constants.TYPE_ITEM_DASHBOARD.RECEPTIONIST ? this.fetchListErrorsReceptionist : this.fetchListErrorsTransactions;
              _context3.n = 1;
              return fn({
                days: this.timeDash,
                params: {
                  startDate: startDate,
                  endDate: endDate,
                  type: this.typeSelected
                }
              });
            case 1:
              data = _context3.v;
              if (data) this.listServicesOnErrorTransactions = data;
              this.isLoadingReceptionist = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getErros() {
        return _getErros.apply(this, arguments);
      }
      return getErros;
    }(),
    openServicesPage: function openServicesPage() {
      this.$router.push({
        name: 'DashboardDetailsService'
      });
    },
    openPainel: function openPainel() {
      this.$router.push({
        name: 'Painel'
      });
    },
    hideDrawerCardDetails: function hideDrawerCardDetails() {
      this.drawerCardDetails.show = false;
    },
    showDrawerCardDetails: function () {
      var _showDrawerCardDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(type, qtyDays, total) {
        var functionBind, remoteData, _t2, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!(total <= 0)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              // Atualiza o estado do drawer para indicar que está carregando
              this.drawerCardDetails.isLoading = true;
              this.drawerCardDetails.show = true;

              // reseta o estado atual
              this.resetDrawerCardDetails();

              // Define a função a ser chamada com base no tipo
              functionBind = this.getClientHiveDataAndSetOnDrawer;
              _t2 = type;
              _context4.n = _t2 === 'hive_provider' ? 2 : _t2 === 'provider_hive' ? 3 : _t2 === 'hive_client' ? 4 : 5;
              break;
            case 2:
              functionBind = this.getHiveProviderDataAndSetOnDrawer;
              return _context4.a(3, 5);
            case 3:
              functionBind = this.getProviderHiveDataAndSetOnDrawer;
              return _context4.a(3, 5);
            case 4:
              functionBind = this.getHiveClientDataAndSetOnDrawer;
              return _context4.a(3, 5);
            case 5:
              _context4.p = 5;
              _context4.n = 6;
              return functionBind(qtyDays);
            case 6:
              remoteData = _context4.v;
              this.setDrawerCardDetails(remoteData.withRequestsError, 'withRequestsError');
              this.setDrawerCardDetails(remoteData.inProcessing, 'inProcessing');
              this.setDrawerCardDetails(remoteData.withSuccess, 'withSuccess');
              this.setDrawerCardDetails(remoteData.withError, 'withError');
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t3 = _context4.v;
              console.error('Erro ao obter dados remotos:', _t3);
            case 8:
              // Atualiza o estado do drawer para indicar que não está mais carregando
              this.drawerCardDetails.isLoading = false;
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[5, 7]]);
      }));
      function showDrawerCardDetails(_x3, _x4, _x5) {
        return _showDrawerCardDetails.apply(this, arguments);
      }
      return showDrawerCardDetails;
    }(),
    setDrawerCardDetails: function setDrawerCardDetails(data, type) {
      var _data$data;
      this.drawerCardDetails[type].show = !!(data !== null && data !== void 0 && data.title);
      this.drawerCardDetails[type].title = data === null || data === void 0 ? void 0 : data.title;
      this.drawerCardDetails[type].partOfTheWhole = data === null || data === void 0 ? void 0 : data.partOfTheWhole;
      this.drawerCardDetails[type].data = data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.perService;
    },
    resetDrawerCardDetails: function resetDrawerCardDetails() {
      var _iterator = _createForOfIteratorHelper(this.listTypes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var itemType = _step.value;
          this.drawerCardDetails[itemType].title = '';
          this.drawerCardDetails[itemType].show = false;
          this.drawerCardDetails[itemType].partOfTheWhole = 0;
          this.drawerCardDetails[itemType].data = [];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    getClientHiveDataAndSetOnDrawer: function () {
      var _getClientHiveDataAndSetOnDrawer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(qtyDays) {
        var serverResponse, totalProcessing, totalSuccess, totalErrors;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.getProtocolsDetailsByPhaseGroupByTypeInLastDays('client-hive', qtyDays);
            case 1:
              serverResponse = _context5.v;
              totalProcessing = {
                absolute: serverResponse.perService.totalProcess,
                percent: parseFloat(serverResponse.perService.totalProcessPercent)
              };
              totalSuccess = {
                absolute: serverResponse.perService.totalSuccess,
                percent: parseFloat(serverResponse.perService.totalSuccessPercent)
              };
              totalErrors = {
                absolute: serverResponse.perService.totalErrors,
                percent: parseFloat(serverResponse.perService.totalErrorsPercent)
              };
              return _context5.a(2, {
                inProcessing: this.getCommonStructuredDataToDrawer('processing', serverResponse, totalProcessing.percent, "CLIENTE \xBB HIVE: ".concat(this.msdkNumber(totalProcessing.absolute), " em processamento")),
                withSuccess: this.getCommonStructuredDataToDrawer('success', serverResponse, totalSuccess.percent, "CLIENTE \xBB HIVE: ".concat(this.msdkNumber(totalSuccess.absolute), " com sucesso")),
                withError: this.getCommonStructuredDataToDrawer('errors', serverResponse, totalErrors.percent, "CLIENTE \xBB HIVE: ".concat(this.msdkNumber(totalErrors.absolute), " com erro"))
              });
          }
        }, _callee5, this);
      }));
      function getClientHiveDataAndSetOnDrawer(_x6) {
        return _getClientHiveDataAndSetOnDrawer.apply(this, arguments);
      }
      return getClientHiveDataAndSetOnDrawer;
    }(),
    getProviderHiveDataAndSetOnDrawer: function () {
      var _getProviderHiveDataAndSetOnDrawer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(qtyDays) {
        var serverResponse, totalProcessing, totalSuccess;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.getProtocolsDetailsByPhaseGroupByTypeInLastDays('provider-hive', qtyDays);
            case 1:
              serverResponse = _context6.v;
              totalProcessing = {
                absolute: serverResponse.perService.totalProcess,
                percent: parseFloat(serverResponse.perService.totalProcessPercent)
              };
              totalSuccess = {
                absolute: serverResponse.perService.totalSuccess,
                percent: parseFloat(serverResponse.perService.totalSuccessPercent)
              };
              return _context6.a(2, {
                inProcessing: this.getCommonStructuredDataToDrawer('processing', serverResponse, totalProcessing.percent, "PROVEDOR \xBB HIVE: ".concat(this.msdkNumber(totalProcessing.absolute), " em processamento")),
                withSuccess: this.getCommonStructuredDataToDrawer('success', serverResponse, totalSuccess.percent, "PROVEDOR \xBB HIVE: ".concat(this.msdkNumber(totalSuccess.absolute), " com sucesso"))
              });
          }
        }, _callee6, this);
      }));
      function getProviderHiveDataAndSetOnDrawer(_x7) {
        return _getProviderHiveDataAndSetOnDrawer.apply(this, arguments);
      }
      return getProviderHiveDataAndSetOnDrawer;
    }(),
    getHiveProviderDataAndSetOnDrawer: function () {
      var _getHiveProviderDataAndSetOnDrawer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(qtyDays) {
        var serverResponse, totalErrors, totalProcessing, totalSuccess;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.getProtocolsDetailsByPhaseGroupByTypeInLastDays('hive-provider', qtyDays);
            case 1:
              serverResponse = _context7.v;
              totalErrors = {
                absolute: serverResponse.perService.totalErrors,
                percent: parseFloat(serverResponse.perService.totalErrorsPercent)
              };
              totalProcessing = {
                absolute: serverResponse.perService.totalProcess,
                percent: parseFloat(serverResponse.perService.totalProcessPercent)
              };
              totalSuccess = {
                absolute: serverResponse.perService.totalSuccess,
                percent: parseFloat(serverResponse.perService.totalSuccessPercent)
              };
              return _context7.a(2, {
                withError: this.getCommonStructuredDataToDrawer('errors', serverResponse, totalErrors.percent, "HIVE \xBB PROVEDOR: ".concat(this.msdkNumber(totalErrors.absolute), " com erro")),
                inProcessing: this.getCommonStructuredDataToDrawer('processing', serverResponse, totalProcessing.percent, "HIVE \xBB PROVEDOR: ".concat(this.msdkNumber(totalErrors.absolute), " em processamento")),
                withSuccess: this.getCommonStructuredDataToDrawer('success', serverResponse, totalSuccess.percent, "HIVE \xBB PROVEDOR: ".concat(this.msdkNumber(totalSuccess.absolute), " com sucesso"))
              });
          }
        }, _callee7, this);
      }));
      function getHiveProviderDataAndSetOnDrawer(_x8) {
        return _getHiveProviderDataAndSetOnDrawer.apply(this, arguments);
      }
      return getHiveProviderDataAndSetOnDrawer;
    }(),
    getHiveClientDataAndSetOnDrawer: function () {
      var _getHiveClientDataAndSetOnDrawer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(qtyDays) {
        var serverResponse, totalErrors, totalErrorsRequests, totalSuccess;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return this.getProtocolsDetailsByPhaseGroupByTypeInLastDays('hive-client', qtyDays);
            case 1:
              serverResponse = _context8.v;
              totalErrors = {
                absolute: serverResponse.perService.totalErrors,
                percent: parseFloat(serverResponse.perService.totalErrorsPercent)
              };
              totalErrorsRequests = {
                absolute: serverResponse.perService.totalErrorRequests,
                percent: parseFloat(serverResponse.perService.totalErrorsRequestsPercent)
              };
              totalSuccess = {
                absolute: serverResponse.perService.totalSuccess,
                percent: parseFloat(serverResponse.perService.totalSuccessPercent)
              };
              return _context8.a(2, {
                withRequestsError: this.getCommonStructuredDataToDrawer('errorsRequests', serverResponse, totalErrorsRequests.percent, "HIVE \xBB CLIENTE: ".concat(this.msdkNumber(totalErrorsRequests.absolute), " com erro")),
                withError: this.getCommonStructuredDataToDrawer('errors', serverResponse, totalErrors.percent, "HIVE \xBB CLIENTE: ".concat(this.msdkNumber(totalErrors.absolute), " n\xE3o recebido")),
                withSuccess: this.getCommonStructuredDataToDrawer('success', serverResponse, totalSuccess.percent, "HIVE \xBB CLIENTE: ".concat(this.msdkNumber(totalSuccess.absolute), " com sucesso"))
              });
          }
        }, _callee8, this);
      }));
      function getHiveClientDataAndSetOnDrawer(_x9) {
        return _getHiveClientDataAndSetOnDrawer.apply(this, arguments);
      }
      return getHiveClientDataAndSetOnDrawer;
    }(),
    getProtocolsDetailsByPhaseGroupByTypeInLastDays: function () {
      var _getProtocolsDetailsByPhaseGroupByTypeInLastDays = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(phase, qtyDays) {
        var perService;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return this.fetchProtocolsDetailsByPhaseGroupByTypeInLastDays({
                phase: phase,
                group: 'service',
                days: qtyDays
              });
            case 1:
              perService = _context9.v;
              return _context9.a(2, {
                perService: perService
              });
          }
        }, _callee9, this);
      }));
      function getProtocolsDetailsByPhaseGroupByTypeInLastDays(_x0, _x1) {
        return _getProtocolsDetailsByPhaseGroupByTypeInLastDays.apply(this, arguments);
      }
      return getProtocolsDetailsByPhaseGroupByTypeInLastDays;
    }(),
    getCommonStructuredDataToDrawer: function getCommonStructuredDataToDrawer(type, originalData, totalPercent, title) {
      var typeKey = 'processList';
      if (type === 'success') typeKey = 'successList';
      if (type === 'errors') typeKey = 'errorList';
      if (type === 'errorsRequests') typeKey = 'errorRequestsList';
      return {
        title: title,
        partOfTheWhole: totalPercent,
        data: {
          perService: originalData.perService[typeKey]
        }
      };
    }
  })
};